import React, { Fragment } from 'react';
import { Banner } from '@spotify-internal/encore-creator-web';
import tokens from '@spotify-internal/encore-foundation';

export function DataAvailabilityAlert() {
  return (
    <Fragment>
      <div style={{ marginTop: tokens.spacer32 }} />
      <Banner variant={Banner.informational} data-qa="analytics-error">
        Analytics for this view are not currently available.
      </Banner>
    </Fragment>
  );
}
